import React, { Fragment } from 'react';
import Legal from '../Legal/Legal'
import FooterHours from './components/FooterHours'
import FooterMeta from './components/FooterMeta'
import './style/_footer.scss'
import Chat from '@sections/Chat/Chat'
import UseFooterQuery from '@staticQueries/footerQuery';

export default function Footer({}) {
  const kontent = UseFooterQuery();
  return (
    <Fragment>
      {/* <Newsletter /> */}
      <Chat />
      <div id="cic-footer-container" className="d-flex">
        <FooterHours data={kontent}/>
      </div>
      <div className='cic-footer-secondary'>
        <FooterMeta data={kontent} />
      </div>
      <Legal />
    </Fragment>
  )
}
